// extracted by mini-css-extract-plugin
module.exports = {"dim":"ClientLoading_dim__Z_ri2","loadingText":"ClientLoading_loadingText__QM2Eq"};